/* eslint-disable */
export default function ZebraWebDriver() {
//var ZebraWebDriver = function () {
    function e(e) {
        return o + e
    }

    function n(e, n) {
        var r = new XMLHttpRequest;
        return "withCredentials" in r ? r.open(e, n, !0) : "undefined" != typeof XDomainRequest ? (r = new XDomainRequest, r.open(e, n)) : r = null, r
    }

    var r = {}, i = 2, o = "http://localhost:9100/";
    return "https:" === location.protocol && (o = "https://localhost:9101/"), r.Device = function (r) {
        this.name = r.name, this.deviceType = r.deviceType, this.connection = r.connection, this.uid = r.uid, this.version = i, this.provider = r.provider, this.manufacturer = r.manufacturer, this.send = function (r, i, o) {
            var t = n("POST", e("write"));
            if (t) {
                void 0 != i && (t.onload = function () {
                    i(t.responseText)
                }), void 0 != o && (t.onerror = function () {
                    o(t.responseText)
                });
                var s = {
                    device: {
                        name: this.name,
                        uid: this.uid,
                        connection: this.connection,
                        deviceType: this.deviceType,
                        version: this.version,
                        provider: this.provider,
                        manufacturer: this.manufacturer
                    }, data: r
                };
                t.send(JSON.stringify(s))
            }
        }, this.sendUrl = function (e, r, i) {
            var o = n("POST", e("write"));
            if (o) {
                void 0 != r && (o.onload = function () {
                    r(o.responseText)
                }), void 0 != i && (o.onerror = function () {
                    i(o.responseText)
                });
                {
                    ({
                        device: {
                            name: this.name,
                            uid: this.uid,
                            connection: this.connection,
                            deviceType: this.deviceType,
                            version: this.version,
                            provider: this.provider,
                            manufacturer: this.manufacturer
                        }, url: e
                    })
                }
                o.send(JSON.stringify(label))
            }
        }, this.read = function (r, i) {
            var o = n("POST", e("read"));
            if (o) {
                void 0 != r && (o.onload = function () {
                    r(o.responseText)
                }), void 0 != i && (o.onerror = function () {
                    i(o.responseText)
                });
                var t = {
                    device: {
                        name: this.name,
                        uid: this.uid,
                        connection: this.connection,
                        deviceType: this.deviceType,
                        version: this.version,
                        provider: this.provider,
                        manufacturer: this.manufacturer
                    }
                };
                o.send(JSON.stringify(t))
            }
        }, this.sendThenRead = function (e, n, r) {
            this.send(e, function (e) {
                return function () {
                    e.read(n, r)
                }
            }(this), r)
        }
    }, r.getLocalDevices = function (i, o, t, s) {
        var a = n("GET", e("available"));
        a && (a.onload = function () {
            var response = a.responseText, response = JSON.parse(response);
            for (var e in response)if (response.hasOwnProperty(e) && response[e].constructor === Array) {
                var arr = response[e];
                for (var n = 0; n < arr.length; ++n)arr[n] = new r.Device(arr[n])
            }
            if (void 0 == t)return void i(response);
            if (void 0 == s)return void i(response[t]);
            for (var o = new Array, n = 0; n < response[t].length; ++n) {
                var u = response[t][n];
                u.manufacturer.toLowerCase() == s.toLowerCase() && o.push(u)
            }
            i(o)
        }, void 0 != o && (a.onerror = a.onerror = function () {
            o(a)
        }), a.send())
    }, r.getDefaultDevice = function (i, o, t) {
        var s = "default";
        void 0 != i && null != i && (s = s + "?type=" + i);
        var a = n("GET", e(s));
        a && (a.onload = function () {
            if (response = a.responseText, "" == response)return void o(null);
            response = JSON.parse(response);
            var e = new r.Device(response);
            o(e)
        }, void 0 != t && (a.onerror = a.onerror = function () {
            t(a)
        }), a.send())
    }, r.readOnInterval = function (e, n, r) {
        var readFunc;
        (void 0 == r || 0 == r) && (r = 1), readFunc = function () {
            e.read(function (e) {
                n(e), setTimeout(readFunc, r)
            }, function () {
                setTimeout(readFunc, r)
            })
        }, setTimeout(readFunc, r)
    }, r.bindFieldToReadData = function (e, n, r, i) {
        readOnInterval(e, function (e) {
            "" != e && (n.value = e, void 0 != i && null != i && i())
        }, r)
    }, r
};
